import { LegacyActionType } from '../../model/types/LegacyActionType';

export const getActionText = (value: LegacyActionType) => {
  switch (value) {
    case 'create':
      return 'создан';
    case 'update':
      return 'обновлен';
    case 'delete':
      return 'удален';
    default:
      return '';
  }
};
